<section *ngIf="!isLoading && transaction">
    <xm-display-card>
        <div class="current-cycle">
            <h3>{{ pageData.costHeader }}</h3>
            <div class="content">
                <xm-media-image aria-hidden="true" [imageOptions]="imageOptions" center="auto"
                    size="height"></xm-media-image>
                <div class="price-detail">
                    <h3>{{ transaction.amount | xmCurrency: 'auto' }}</h3>
                    <!--TO DO: uncomment and switch API data-->
                    <!-- <p class="duration">20 days left in bill cycle</p> -->
                    <p class="description-text">{{ pageData.dataDescription }}</p>
                </div>
                <div class="links">
                    <a uiSref="account.billing.landing" class="xm-btn-secondary-light">{{ pageData.buttonText }}</a>
                </div>
            </div>
        </div>
    </xm-display-card>
</section>
<section *ngIf="isLoading">
    <xm-loader-overlay type="billing-card" page="billing" [avatar]="true"></xm-loader-overlay>
</section>
